<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('checking')">
            <app-default-button
                :title="$fieldTitle('add', 'checking', true)"
                v-if="$can('create_hotel_checking')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="checking-table"
            :options="options"
            @action="triggerActions"
        />

        <app-hotel-checking-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('checking-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import HotelCheckingMixins from "../../../Mixins/HotelCheckingMixins";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";

export default {
    name  : "AppHotelChecking",
    mixins: [HelperMixin, HotelCheckingMixins, TENANT_BASE_URL],
    data() {
        return {
            isModalTypeActive: false,
            isModalActive    : false,
            selectedUrl      : '',
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/hotel/checking/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    }
}
</script>